var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "caca" },
    [
      _vm.balanceLoader || _vm.processing
        ? _c(
            "div",
            { staticClass: "payments__spinner" },
            [
              _c("v-progress-circular", {
                staticClass: "redirecting-circular-progress",
                attrs: { indeterminate: "" }
              }),
              _vm._v(
                "\n    " + _vm._s(_vm.$t("Transaction.PleaseWait")) + "\n  "
              )
            ],
            1
          )
        : _c("div", [
            _vm.transactionType === "deposit"
              ? _c("div", [
                  _c(
                    "h2",
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { color: "success" } },
                        [_vm._v("check_circle")]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.$t("Payments.PNM.Completed.Headline.Deposit")
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("Payments.PNM.Completed.Deposit")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.transactionType === "withdrawal"
              ? _c("div", [
                  _c(
                    "h2",
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { color: "success" } },
                        [_vm._v("check_circle")]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.$t("Payments.PNM.Completed.Headline.Withdrawal")
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("Payments.PNM.Completed.Withdrawal")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "goto__home" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { large: "", color: "success" },
                    on: {
                      click: function($event) {
                        return _vm.goToHomepage()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Account.ChangePassword.GoToHomepage"))
                    )
                  ]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("PNMEventDispatcher", { attrs: { paymentIsCompleted: true } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5876a363", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5876a363","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/PayNearMeGateway/PNMPaymentCompleted.vue
// module id = null
// module chunks = 